import Tesseract from "tesseract.js";

export const validarArchivo = async (file) => {
  const isPDF = file.type === "application/pdf";
  let imageBitmap = null;

  if (isPDF) {
    const pdfjsLib = await import("pdfjs-dist/legacy/build/pdf");
    pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

    const pdf = await pdfjsLib.getDocument(await file.arrayBuffer()).promise;
    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: 2 }); // Más detalle para nitidez
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    await page.render({ canvasContext: context, viewport }).promise;
    imageBitmap = canvas;
  } else {
    const image = new Image();
    const objectUrl = URL.createObjectURL(file);
    await new Promise((resolve) => {
      image.onload = () => resolve();
      image.src = objectUrl;
    });
    imageBitmap = image;
  }

  const resultados = {
    blurry: false,
    bright: false,
    isCropped: false,
    hasFace: true,
  };

  // --- Validación de nitidez ---
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = imageBitmap.width;
  canvas.height = imageBitmap.height;
  ctx.drawImage(imageBitmap, 0, 0, canvas.width, canvas.height);
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

  let edgeSum = 0;
  for (let i = 0; i < imageData.data.length - 4; i += 4) {
    const gray =
      (imageData.data[i] + imageData.data[i + 1] + imageData.data[i + 2]) / 3;
    const nextGray =
      (imageData.data[i + 4] + imageData.data[i + 5] + imageData.data[i + 6]) /
      3;
    if (gray < 30 || gray > 225) continue; // ignora extremos
    edgeSum += Math.abs(gray - nextGray);
  }
  const avgEdge = edgeSum / (imageData.data.length / 4);

  if (avgEdge < 2) {
    resultados.blurry = true;
  }

  // --- OCR con idioma español ---
  try {
    const result = await Tesseract.recognize(imageBitmap, "spa", {
      logger: (m) => console.log(m),
    });
    const cleanText = result.data.text.replace(/\s/g, "");
    if (cleanText.length < 10) {
      resultados.blurry = true;
    }
  } catch (err) {
    console.warn(
      "Error de OCR, no se marcará automáticamente como borroso:",
      err.message
    );
  }

  return resultados;
};
